'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useStore } from 'zustand';

import { modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { authStore } from '@/store/auth.store';
import { LoginOriginEnum } from '@/types/enums/analytics/login/login-analytics.enum';

export function useRequireAuthentication(isAuthenticationMissing: boolean) {
  const router = useRouter();
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  const hasAskedRef = useRef(false);
  const hasBeenLoggedInRef = useRef(false);

  useEffect(() => {
    if (isLoggedIn) {
      hasBeenLoggedInRef.current = true;
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isAuthenticationMissing) {
      return;
    }

    if (hasAskedRef.current || hasBeenLoggedInRef.current) {
      router.replace('/');
      return;
    }

    hasAskedRef.current = true;

    const dismissCallback = () => router.replace('/');

    setOpenSignInModal(true, { origin: LoginOriginEnum.PROTECTED_PAGE, dismissCallback });

    return () => {
      if (modalsOpeningStore.getState().dismissCallback === dismissCallback) {
        modalsOpeningStore.setState({ dismissCallback: undefined });
      }
    };
  }, [isAuthenticationMissing, router]);
}
